<!-- Hero Section -->
<section class="hero-section">
    <div class="page-title-area">
        <img src="assets/images/ipad-air/hero.png" alt="Page Background" class="page-bg" style="width: 70%; height: 70%; object-fit: contain; position: absolute; left: 30%; top: 10%; transform: translateX(20%);">
        <div class="container">
            <div class="hero-content">
                <img src="assets/images/ipad-air/logo.png" alt="iPad Air" class="hero-logo">
                <h2 style="background: rgba(0, 125, 250, 0.6);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-size: 52px;
                line-height: 1.1;">Flight speed.</h2>
                <p>The beautifully designed iPad Air. Two portable sizes. Powerful Apple M3 chip. Built for Apple Intelligence. In four stunning colors.</p>
            </div>
        </div>
    </div>
</section>

<!-- Features Section -->
<section class="features-section">
    <div class="container">
        <!-- Display Info Card -->
        <div class="feature-card display-info-card mb-5">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <img src="assets/images/ipad-air/size.png" alt="iPad Air Display" class="display-image">
                </div>
                <div class="col-lg-6">
                    <h2 class="display-title">Available in 11‑inch and 13‑inch models with stunning Liquid Retina display.</h2>
                </div>
            </div>
        </div>

        <!-- Three Card Layout -->
        <div class="row">
            <!-- Left Large Card -->
            <div class="col-lg-9">
                <div class="feature-card h-100" style="position: relative; overflow: hidden;">
                    <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></div>
                    <img src="assets/images/ipad-air/gpu.png" alt="iPad Air M3" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; opacity: 0.8;">
                    <div class="row align-items-center h-100" style="position: relative; z-index: 2;">
                        <div class="col-lg-12">
                            <h2 class="display-title1">iPad Air is built for Apple Intelligence. Apple M3 chip powers incredible performance and advanced graphics.</h2>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Column Cards -->
            <div class="col-lg-3 d-flex flex-column h-100">
                <!-- Top Right Card -->
                <div class="feature-card flex-grow-1" style="height: 49%; background: linear-gradient(180deg, #004c94 10%, #1663ac 45%, #297bc4 80%);">
                    <div class="h-100 d-flex flex-column justify-content-center">
                        <img src="assets/images/ipad-air/battery.png" style="width: 100px; height: 100px;" alt="iPad Air Battery" class="feature-image mb-4">
                        <h2 class="display-title2" style="">All‑day battery life to work, learn, create, and play.</h2>
                    </div>
                </div>

                <!-- Bottom Right Card -->
                <div class="feature-card flex-grow-1 mt-3" style="height: 49%; background: linear-gradient(180deg, #004c94 10%, #1663ac 45%, #297bc4 80%);">
                    <div class="h-100 d-flex flex-column justify-content-center">
                        <img src="assets/images/ipad-air/storage.png" style="width: 100px; height: 100px;" alt="iPad Air Storage" class="feature-image mb-4">
                        <h2 style="color: white;
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 1.1;">Storage starting at 128GB.</h2>
                    </div>
                </div>
            </div>
        </div>

        <!-- Two Card Layout -->
        <div class="row mt-5">
            <!-- Left Card (35%) -->
            <div class="col-lg-4">
                <div class="feature-card h-100">
                    <div class="h-100 d-flex flex-column">
                        <h2 style="background: linear-gradient(180deg, #004c94 10%, #1663ac 45%, #297bc4 80%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        font-size: 30px;
                        font-weight: 500;
                        line-height: 1.1;
                        margin-bottom: 30px;">Blazing‑fast Wi‑Fi and 5G connectivity.</h2>
                        <div style="flex-grow: 1; display: flex; align-items: flex-end;">
                            <img src="assets/images/ipad-air/wifi.png" alt="iPad Air WiFi" style="width: 100%; height: auto;">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Card (65%) -->
            <div class="col-lg-8">
                <div class="feature-card h-100">
                    <div class="h-100 d-flex flex-column">
                        <div style="flex-grow: 1;">
                            <img src="assets/images/ipad-air/camera.png" alt="iPad Air Camera" style="width: 100%; height: auto; margin-bottom: 30px;">
                        </div>
                        <h2 style="background: linear-gradient(180deg, #004c94 10%, #1663ac 45%, #297bc4 80%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        font-size: 30px;
                        font-weight: 500;
                        line-height: 1.1;">12MP Center Stage camera for even better video calls.</h2>
                    </div>
                </div>
            </div>
        </div>

        <!-- Apple Intelligence Card -->
        <div class="row mt-5">
            <div class="col-lg-12">
                <div class="feature-card h-100" style="background: rgb(243 246 246); position: relative; overflow: hidden;">
                    <div class="row h-100">
                        <div class="col-lg-12">
                            <div class="text-center">
                                <img src="assets/images/ipad-air/ai.png" alt="Apple Intelligence"
                                    style="width: 100px; height: auto; object-fit: contain; margin-bottom: 30px;">
                                <h2 class="display-title3" >
                                    Built for Apple Intelligence.</h2>
                                <p class="display-title4">
                                    Helps you write, express yourself, and get things done effortlessly while giving you peace of mind with
                                    groundbreaking privacy protections.
                                </p>
                                <p class="display-title4">
                                    Available now in English
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Apple Pencil Card -->
        <div class="row mt-5">
            <div class="col-lg-12">
                <div class="feature-card" style="position: relative; overflow: hidden; height: 600px; background: #f5f5f7;">
                    <div class="position-absolute start-0 p-5" style="max-width: 100%; z-index: 2;">
                        <h2 style="color: #0066CC; font-size: 48px; font-weight: 600; line-height: 1.1; margin-bottom: 20px;">
                            Apple Pencil Pro.
                        </h2>
                        <h3 class="display-title5" style="">
                            With powerful features for<br>next‑level creativity.
                        </h3>
                    </div>
                    <img src="assets/images/ipad-air/apple_pencil.png" alt="Apple Pencil Pro" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; height: auto; object-fit: contain;">
                </div>
            </div>
        </div>

        <!-- Two Cards Layout -->
        <div class="row mt-5">
            <!-- Left Card - Magic Keyboard -->
            <div class="col-lg-6">
                <div class="feature-card" style="background: #f5f5f7; border-radius: 20px; padding: 60px; height: 600px;">
                    <div class="d-flex flex-column h-100">
                        <div style="flex-grow: 1; position: relative;">
                            <img src="assets/images/ipad-air/keyboard.png" alt="Magic Keyboard" style="position: absolute; left: -40px; bottom: 0; width: 90%; height: auto;">
                        </div>
                        <div style="position: relative; z-index: 2;">
                            <h2 class="display-title6">
                                Magic Keyboard. An amazing typing experience now with a larger trackpad and function row.
                            </h2>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Card - iPadOS -->
            <div class="col-lg-6">
                <div class="feature-card" style="background: #f5f5f7; border-radius: 20px; padding: 20px; height: 600px;">
                    <div class="d-flex flex-column h-100">
                        <div style="position: relative; z-index: 2;">
                            <h2 class="display-title6">
                                Get things done in magical and intuitive ways with iPadOS and incredible apps.
                            </h2>
                        </div>
                        <div style="flex-grow: 1; position: relative; margin-top: 40px;">
                            <img src="assets/images/ipad-air/os.png" alt="iPadOS" style="position: absolute; width: 100%; height: auto;">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Why iPad Section -->
        <div class="row mt-5">
            <div class="col-lg-12">
                <div class="feature-card" style="border-radius: 20px; padding: 20px;">
                    <div class="why-ipad-section">
                        <h3 class="display-title7">Why iPad</h3>
                        <h2 class="display-title8">There's nothing quite like iPad.</h2>
                        
                        <div class="row">
                            <!-- Easy to use -->
                            <div class="col-lg-3">
                                <div class="feature-item text-center">
                                    <img src="assets/images/ipad-air/easy.png" alt="Easy to use" style="width: 56px; height: 56px; margin-bottom: 20px;">
                                    <h4 style="color: #1d1d1f; font-size: 24px; font-weight: 600; margin-bottom: 10px;">Easy to use</h4>
                                    <p style="color: #86868b; font-size: 17px; line-height: 1.5;">iPad lets you do everything in powerful yet simple ways on the large Multi‑Touch display.</p>
                                </div>
                            </div>

                            <!-- Powerful -->
                            <div class="col-lg-3">
                                <div class="feature-item text-center">
                                    <img src="assets/images/ipad-air/powerful.png" alt="Powerful" style="width: 56px; height: 56px; margin-bottom: 20px;">
                                    <h4 style="color: #1d1d1f; font-size: 24px; font-weight: 600; margin-bottom: 10px;">Powerful</h4>
                                    <p style="color: #86868b; font-size: 17px; line-height: 1.5;">Run apps like Microsoft 365, Adobe Photoshop, and graphics‑intensive games. iPad is ready for anything.</p>
                                </div>
                            </div>

                            <!-- Portable -->
                            <div class="col-lg-3">
                                <div class="feature-item text-center">
                                    <img src="assets/images/ipad-air/portable.png" alt="Portable" style="width: 56px; height: 56px; margin-bottom: 20px;">
                                    <h4 style="color: #1d1d1f; font-size: 24px; font-weight: 600; margin-bottom: 10px;">Portable</h4>
                                    <p style="color: #86868b; font-size: 17px; line-height: 1.5;">Remarkably thin and light with a durable design, fast Wi‑Fi and optional 5G and cellular data plans, and all‑day battery life.</p>
                                </div>
                            </div>

                            <!-- Versatile -->
                            <div class="col-lg-3">
                                <div class="feature-item text-center">
                                    <img src="assets/images/ipad-air/versatile.png" alt="Versatile" style="width: 56px; height: 56px; margin-bottom: 20px;">
                                    <h4 style="color: #1d1d1f; font-size: 24px; font-weight: 600; margin-bottom: 10px;">Versatile</h4>
                                    <p style="color: #86868b; font-size: 17px; line-height: 1.5;">It's your notepad, film studio, scanner, mobile office, and canvas when you need one.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

